// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Ionic CSS Variables **/
:root {
  --ion-color-primary: #E82973;
  --ion-color-primary-rgb: 232, 41, 115;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #cd2367;
  --ion-color-primary-tint: #F7ACC9;
  --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);
  --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);
  --ion-color-secondary: #343434;
  --ion-color-secondary-rgb: 52, 52, 52;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #2e2e2e;
  --ion-color-secondary-tint: #484848;
  --ion-color-tertiary: #007AFF;
  --ion-color-tertiary-rgb: 0, 122, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
  --ion-color-tertiary-shade: #006be0;
  --ion-color-tertiary-tint: #1a87ff;
  --ion-color-success: #07AE1D;
  --ion-color-success-rgb: 7, 174, 29;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #06991a;
  --ion-color-success-tint: #20b634;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #E92828;
  --ion-color-danger-rgb: 233, 40, 40;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cd2323;
  --ion-color-danger-tint: #eb3e3e;
  --ion-color-dark: #343434;
  --ion-color-dark-rgb: 52, 52, 52;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #2e2e2e;
  --ion-color-dark-tint: #484848;
  --ion-color-medium: #707070;
  --ion-color-medium-rgb: 112, 112, 112;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #636363;
  --ion-color-medium-tint: #7e7e7e;
  --ion-color-light: #FCFCFF;
  --ion-color-light-rgb: 252, 252, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #F6F6F6;
  --ion-color-light-tint: #fcfcff;
  --ion-color-white: #fff;
  --ion-text-color-primary: 42, 42, 42;
  --ion-text-color-Secondary: #EF5492;
  --ion-font-family: "Segoe UI";
  --app-padding-from-top: 30px;
}

.ios body,
.md body {
  --ion-color-primary: #E82973;
  --ion-color-primary-rgb: 232, 41, 115;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #cd2367;
  --ion-color-primary-tint: #F7ACC9;
  --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);
  --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);
  --ion-color-secondary: #343434;
  --ion-color-secondary-rgb: 52, 52, 52;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #2e2e2e;
  --ion-color-secondary-tint: #484848;
  --ion-color-tertiary: #5260ff;
  --ion-color-tertiary-rgb: 82, 96, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
  --ion-color-tertiary-shade: #4854e0;
  --ion-color-tertiary-tint: #6370ff;
  --ion-color-success: #07AE1D;
  --ion-color-success-rgb: 7, 174, 29;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #06991a;
  --ion-color-success-tint: #20b634;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #E92828;
  --ion-color-danger-rgb: 233, 40, 40;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cd2323;
  --ion-color-danger-tint: #eb3e3e;
  --ion-color-dark: #343434;
  --ion-color-dark-rgb: 52, 52, 52;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #2e2e2e;
  --ion-color-dark-tint: #484848;
  --ion-color-medium: #707070;
  --ion-color-medium-rgb: 112, 112, 112;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #636363;
  --ion-color-medium-tint: #7e7e7e;
  --ion-color-light: #FCFCFF;
  --ion-color-light-rgb: 252, 252, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #F6F6F6;
  --ion-color-light-tint: #fcfcff;
  --ion-color-white: #fff;
  --ion-text-color-primary: 42, 42, 42;
  --ion-text-color-Secondary: #EF5492;
  --ion-font-family: "Segoe UI";
  --ion-background-color: var(--ion-color-light);
  --ion-background-color-rgb: var(--ion-color-light-rgb);
  --ion-text-color: var(--ion-color-dark);
  --ion-text-color-rgb: var(--ion-color-dark-rgb);
  --ion-color-step-50: #0d0d0d;
  --ion-color-step-100: #1a1a1a;
  --ion-color-step-150: #262626;
  --ion-color-step-200: #333333;
  --ion-color-step-250: #404040;
  --ion-color-step-300: #4d4d4d;
  --ion-color-step-350: #595959;
  --ion-color-step-400: #666666;
  --ion-color-step-450: #737373;
  --ion-color-step-500: #808080;
  --ion-color-step-550: #8c8c8c;
  --ion-color-step-600: #999999;
  --ion-color-step-650: #a6a6a6;
  --ion-color-step-700: #b3b3b3;
  --ion-color-step-750: #bfbfbf;
  --ion-color-step-800: #cccccc;
  --ion-color-step-850: #d9d9d9;
  --ion-color-step-900: #e6e6e6;
  --ion-color-step-950: #f2f2f2;
  --ion-item-background: transparent;
  --ion-card-background: #fff;
  /* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)
  @media (prefers-color-scheme: dark) {
      --ion-background-color: #17171A;
      --ion-background-color-rgb: 23, 23, 26;
      --ion-text-color: #F2F2F2;
      --ion-text-color-rgb: 242, 242, 242;
      color: var(--ion-text-color);
      background: var(--ion-background-color);
  }
  */
}

:root {
  --brand: #E82973;
  --bg-app: #FFFFFF;
  --surface-card: #F5F5F5;
  --border-token: #E5E5E5;
  --text-primary-token: #1A1A1A;
  --text-secondary-token: #777777;
  --text-muted-token: #999999;
}

/* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)
@media (prefers-color-scheme: dark) {
  :root {
    --brand: #E82973;
    --bg-app: #17171A;
    --surface-card: #3F3F45;
    --border-token: #3A3A3D;
    --text-primary-token: #F2F2F2;
    --text-secondary-token: #A0A0A5;
    --text-muted-token: #6E6E73;
    --ion-background-color: #17171A;
    --ion-background-color-rgb: 23, 23, 26;
    --ion-text-color: #F2F2F2;
    --ion-text-color-rgb: 242, 242, 242;
  }
}
*/
/** Ionic CSS Variables **/
:root {
  --ion-color-primary: #E82973;
  --ion-color-primary-rgb: 232, 41, 115;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #cd2367;
  --ion-color-primary-tint: #F7ACC9;
  --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);
  --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);
  --ion-color-secondary: #343434;
  --ion-color-secondary-rgb: 52, 52, 52;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #2e2e2e;
  --ion-color-secondary-tint: #484848;
  --ion-color-tertiary: #007AFF;
  --ion-color-tertiary-rgb: 0, 122, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
  --ion-color-tertiary-shade: #006be0;
  --ion-color-tertiary-tint: #1a87ff;
  --ion-color-success: #07AE1D;
  --ion-color-success-rgb: 7, 174, 29;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #06991a;
  --ion-color-success-tint: #20b634;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #E92828;
  --ion-color-danger-rgb: 233, 40, 40;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cd2323;
  --ion-color-danger-tint: #eb3e3e;
  --ion-color-dark: #343434;
  --ion-color-dark-rgb: 52, 52, 52;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #2e2e2e;
  --ion-color-dark-tint: #484848;
  --ion-color-medium: #707070;
  --ion-color-medium-rgb: 112, 112, 112;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #636363;
  --ion-color-medium-tint: #7e7e7e;
  --ion-color-light: #FCFCFF;
  --ion-color-light-rgb: 252, 252, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #F6F6F6;
  --ion-color-light-tint: #fcfcff;
  --ion-color-white: #fff;
  --ion-text-color-primary: 42, 42, 42;
  --ion-text-color-Secondary: #EF5492;
  --ion-font-family: "Segoe UI";
  --app-padding-from-top: 30px;
}

.ios body,
.md body {
  --ion-color-primary: #E82973;
  --ion-color-primary-rgb: 232, 41, 115;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #cd2367;
  --ion-color-primary-tint: #F7ACC9;
  --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);
  --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);
  --ion-color-secondary: #343434;
  --ion-color-secondary-rgb: 52, 52, 52;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #2e2e2e;
  --ion-color-secondary-tint: #484848;
  --ion-color-tertiary: #5260ff;
  --ion-color-tertiary-rgb: 82, 96, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
  --ion-color-tertiary-shade: #4854e0;
  --ion-color-tertiary-tint: #6370ff;
  --ion-color-success: #07AE1D;
  --ion-color-success-rgb: 7, 174, 29;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #06991a;
  --ion-color-success-tint: #20b634;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #E92828;
  --ion-color-danger-rgb: 233, 40, 40;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cd2323;
  --ion-color-danger-tint: #eb3e3e;
  --ion-color-dark: #343434;
  --ion-color-dark-rgb: 52, 52, 52;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #2e2e2e;
  --ion-color-dark-tint: #484848;
  --ion-color-medium: #707070;
  --ion-color-medium-rgb: 112, 112, 112;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #636363;
  --ion-color-medium-tint: #7e7e7e;
  --ion-color-light: #FCFCFF;
  --ion-color-light-rgb: 252, 252, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #F6F6F6;
  --ion-color-light-tint: #fcfcff;
  --ion-color-white: #fff;
  --ion-text-color-primary: 42, 42, 42;
  --ion-text-color-Secondary: #EF5492;
  --ion-font-family: "Segoe UI";
  --ion-background-color: var(--ion-color-light);
  --ion-background-color-rgb: var(--ion-color-light-rgb);
  --ion-text-color: var(--ion-color-dark);
  --ion-text-color-rgb: var(--ion-color-dark-rgb);
  --ion-color-step-50: #0d0d0d;
  --ion-color-step-100: #1a1a1a;
  --ion-color-step-150: #262626;
  --ion-color-step-200: #333333;
  --ion-color-step-250: #404040;
  --ion-color-step-300: #4d4d4d;
  --ion-color-step-350: #595959;
  --ion-color-step-400: #666666;
  --ion-color-step-450: #737373;
  --ion-color-step-500: #808080;
  --ion-color-step-550: #8c8c8c;
  --ion-color-step-600: #999999;
  --ion-color-step-650: #a6a6a6;
  --ion-color-step-700: #b3b3b3;
  --ion-color-step-750: #bfbfbf;
  --ion-color-step-800: #cccccc;
  --ion-color-step-850: #d9d9d9;
  --ion-color-step-900: #e6e6e6;
  --ion-color-step-950: #f2f2f2;
  --ion-item-background: transparent;
  --ion-card-background: #fff;
  /* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)
  @media (prefers-color-scheme: dark) {
      --ion-background-color: #17171A;
      --ion-background-color-rgb: 23, 23, 26;
      --ion-text-color: #F2F2F2;
      --ion-text-color-rgb: 242, 242, 242;
      color: var(--ion-text-color);
      background: var(--ion-background-color);
  }
  */
}

:root {
  --brand: #E82973;
  --bg-app: #FFFFFF;
  --surface-card: #F5F5F5;
  --border-token: #E5E5E5;
  --text-primary-token: #1A1A1A;
  --text-secondary-token: #777777;
  --text-muted-token: #999999;
}

/* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)
@media (prefers-color-scheme: dark) {
  :root {
    --brand: #E82973;
    --bg-app: #17171A;
    --surface-card: #3F3F45;
    --border-token: #3A3A3D;
    --text-primary-token: #F2F2F2;
    --text-secondary-token: #A0A0A5;
    --text-muted-token: #6E6E73;
    --ion-background-color: #17171A;
    --ion-background-color-rgb: 23, 23, 26;
    --ion-text-color: #F2F2F2;
    --ion-text-color-rgb: 242, 242, 242;
  }
}
*/
:host ion-header {
  position: relative;
  top: 0px;
  left: 0;
  right: 0;
  width: 100%;
  --box-shadow: none;
  box-shadow: none;
  background: transparent;
  padding-top: 12px;
  padding-bottom: 12px;
  --background: transparent;
}
:host ion-header:after {
  display: none;
}
:host ion-header ion-toolbar {
  --background: transparent;
  --border-width: 0px;
  color: var(--ion-color-secondary);
  --min-height: 40px;
  --padding-bottom: 5px;
  --padding-top: 5px;
  --padding-start: 20px;
  --padding-end: 15px;
  --box-shadow: none;
  position: relative;
}
:host ion-header ion-toolbar ion-buttons {
  margin: 0;
}
:host ion-header ion-toolbar ion-buttons ion-button {
  margin: 0;
  --background: transparent;
  box-shadow: none;
  --background-focused: transparent;
  --background-focused-opacity: 0;
  --background-hover: transparent;
  --background-hover-opacity: 0;
  --background-activated: transparent;
  --background-activated-opacity: 0;
  --border-radius: 0;
  border-radius: 0;
  --color: var(--ion-color-secondary);
  --padding-end: 0;
  --padding-top: 3px;
  --padding-bottom: 3px;
  --padding-start: 0;
  font-size: 24px;
}
:host ion-header ion-toolbar ion-buttons ion-button .menu-btn {
  position: relative;
}
:host ion-header ion-toolbar ion-buttons ion-back-button {
  --color: rgba(var(--ion-color-secondary-rgb), 0.9);
}
:host ion-header ion-toolbar ion-title {
  text-align: center;
  font-size: 1.3333333333rem;
  font-weight: 600;
  position: absolute;
  left: 50%;
  padding: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 200px;
  line-height: 1.5;
}
:host ion-header ion-toolbar ion-title.logo {
  position: absolute;
  left: 50%;
  right: 0;
  top: 50%;
  padding: 0;
  transform: translate(-50%, -50%);
}
:host ion-header ion-toolbar ion-title.logo img {
  max-width: 7.2777777778rem;
  height: auto;
  display: inline-block;
}
:host ion-header.greyHeader {
  background: var(--ion-color-light-shade);
  --background: var(--ion-color-light-shade);
}
:host ion-content {
  --padding-top: 0;
  --offset-bottom: -100px;
}

:host .sc-ion-modal-md-h {
  --max-width: 90% !important;
  --max-height: 60% !important;
  --width: 90% !important;
  --height: 60% !important;
  border-radius: 5% !important;
}
:host ion-header {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  width: 100%;
  --box-shadow: none;
  background: transparent;
  padding-top: 30px;
  padding-bottom: 10px;
  font-family: var(--ion-font-family-secondary);
}
:host ion-header ion-toolbar {
  background: transparent;
}
:host ion-header ion-toolbar ion-buttons ion-back-button {
  --background: rgba(255, 255, 255, 0.8);
  --min-height: 49px;
  --min-width: 51px;
  --border-radius: 14px;
  color: var(--ion-color-secondary);
  --icon-font-weight: 300;
}
:host ion-header ion-toolbar ion-buttons ion-back-button.edit-btn {
  --border-radius: 50%;
  width: 42px;
  height: 42px;
  --background: var(--ion-color-white);
}
:host ion-header ion-toolbar ion-buttons ion-button.edit-btn {
  --border-radius: 50%;
  width: 42px;
  height: 42px;
  --background: var(--ion-color-white);
}
:host ion-header ion-toolbar ion-buttons ion-button.edit-btn ion-icon {
  font-size: 25px;
  color: var(--ion-color-secondary);
}
:host ion-header ion-toolbar ion-buttons ion-button.favorite-btn {
  --border-radius: 50%;
  width: 42px;
  height: 42px;
  --background: rgba(255, 255, 255, 0.85);
  --box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}
:host ion-header ion-toolbar ion-buttons ion-button.favorite-btn ion-icon {
  font-size: 22px;
  color: #E82973;
}
:host ion-header ion-toolbar ion-buttons ion-button.favorite-btn ion-icon.favorited {
  color: #E82973;
}
:host ion-content .user-profile-slider {
  z-index: 1;
  position: relative;
  min-height: 200px;
  max-height: 320px;
  overflow: hidden;
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.3);
  border-radius: 0 0 20px 20px;
}
:host ion-content .user-profile-slider swiper-container swiper-slide {
  margin: 0 auto;
  min-height: 320px;
  max-height: 320px;
}
:host ion-content .user-profile-slider swiper-container swiper-slide .slideHolder {
  position: relative;
  min-height: 180px;
  max-height: 320px;
}
:host ion-content .user-profile-slider swiper-container swiper-slide .slideHolder img {
  margin: auto;
  max-height: 320px;
  height: 100%;
  object-fit: contain;
}
:host ion-content .user-profile-slider .slideDots {
  position: absolute;
  bottom: 14px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  z-index: 99;
}
:host ion-content .user-profile-slider .slideDots span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  transition: background 0.2s;
}
:host ion-content .user-profile-slider .slideDots span.active {
  background: #E82973;
}
:host ion-content .product-details-wrapper {
  padding: 5px 15px 20px;
}
:host ion-content .product-details-wrapper ion-col {
  padding: 12px 0 12px 3px;
  border-bottom: 1px solid #E5E5E5;
  min-height: unset;
}
:host ion-content .product-details-wrapper ion-col.intro {
  border-bottom: none;
  padding: 0;
}
:host ion-content .product-details-wrapper ion-col.intro ion-text.title {
  font-size: 0.8888888889rem;
  font-weight: 700;
  margin: 0 0 7px;
  color: #1A1A1A;
}
:host ion-content .product-details-wrapper ion-col.intro ion-text.title.userName {
  font-size: 0.7777777778rem;
  font-weight: 700;
  color: #1A1A1A;
}
:host ion-content .product-details-wrapper ion-col.intro ion-text.date {
  font-size: 0.7777777778rem;
  font-weight: 400;
  margin: 0;
  color: #777777;
}
:host ion-content .product-details-wrapper ion-col.intro ion-button {
  font-size: 0.9444444444rem;
  font-weight: 600;
}
:host ion-content .product-details-wrapper ion-col.intro address {
  font-size: 0.8888888889rem;
  font-weight: 400;
  margin: 0 0 10px;
  color: #777777;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
:host ion-content .product-details-wrapper ion-col.intro address ion-icon {
  font-size: 14px;
  flex-shrink: 0;
}
:host ion-content .product-details-wrapper ion-col.intro address span {
  max-width: 200px;
  margin: 0px 0 0 3px;
  font-size: 0.7777777778rem;
  font-style: normal;
  line-height: 1.4;
}
:host ion-content .product-details-wrapper ion-col.intro ion-avatar {
  max-width: 40px;
  width: 100%;
  height: 40px;
  margin: 0 0 5px;
}
:host ion-content .product-details-wrapper ion-col.intro ion-avatar img {
  width: 100%;
  height: 100%;
}
:host ion-content .product-details-wrapper ion-col.intro ion-button.btn-link {
  --color: #E82973;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --min-height: auto;
  --box-shadow: none;
  --ripple-color: transparent;
  --background-hover: transparent;
  --background-focused: transparent;
  --background-activated: transparent;
  --background-hover-opacity: 0;
  --background-focused-opacity: 0;
  --background-activated-opacity: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  font-size: 0.7777777778rem;
  font-weight: 700;
  height: auto;
  min-height: 32px;
  margin: -6px 0 -6px -8px;
  text-transform: none;
  box-shadow: none;
  outline: none;
}
:host ion-content .product-details-wrapper ion-col.intro ion-button.btn-link::part(native) {
  box-shadow: none;
}
:host ion-content .product-details-wrapper ion-col.specs ion-text.spec-title {
  font-size: 0.7777777778rem;
  margin: 0 0;
  font-weight: 400;
  color: #777777;
}
:host ion-content .product-details-wrapper ion-col.specs .right-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
:host ion-content .product-details-wrapper ion-col.specs .right-content ion-text {
  font-size: 0.7777777778rem;
  color: #1A1A1A;
}
:host ion-content .product-details-wrapper ion-col.specs .right-content .grey-block {
  padding: 5px;
  border-radius: 6px;
  background: #FBEAF0;
  color: #E82973;
  margin: 0 8px;
  min-width: 30px;
  text-align: center;
  height: 30px;
  font-size: 0.7777777778rem;
  font-weight: 700;
}
:host ion-content .product-details-wrapper ion-col.specs .right-content .grey-block.active {
  color: #E82973;
  background: #FBEAF0;
}
:host ion-content .product-details-wrapper ion-col.specs .right-content .grey-block.round {
  border-radius: 50%;
}
:host ion-content .product-details-wrapper ion-col.specs .right-content .grey-block.round.red {
  background-color: var(--ion-color-danger);
}
:host ion-content .descTitle {
  margin: 0 0 8px;
  line-height: 1.5;
  font-size: 0.8888888889rem;
  font-weight: 700;
  color: #1A1A1A;
}
:host ion-content h5.descTitle + ion-text {
  font-size: 0.7777777778rem;
  color: #777777;
  line-height: 1.5;
}
:host ion-content .notifications {
  margin-top: 27px;
  background: rgba(var(--ion-color-primary-rgb), 0.1);
}
:host ion-footer {
  background: #FFFFFF;
  --background: #FFFFFF;
  padding: 20px 23px 30px;
}
:host ion-footer ion-button {
  margin: 0;
}

.sc-ion-modal-md-h {
  --max-width: 90% !important;
  --max-height: 60% !important;
  --width: 90% !important;
  --height: 60% !important;
  --border-radius: 5% !important;
}

.my-custom-class {
  --max-width: 90% !important;
  --max-height: 60% !important;
  --width: 90% !important;
  --height: 60% !important;
  border-radius: 5% !important;
}

.zoom-img {
  width: 100%;
  height: auto;
  display: block;
  touch-action: none;
}

.product-not-found-block {
  text-align: center;
  padding: 40px 20px;
}
.product-not-found-block ion-icon {
  font-size: 48px;
  color: var(--ion-color-primary);
  margin-bottom: 12px;
}
.product-not-found-block ion-text {
  display: block;
  font-size: 0.8888888889rem;
  color: #1A1A1A;
  margin-bottom: 20px;
}
.product-not-found-block .theme-btn {
  max-width: 260px;
  margin: 0 auto;
}

.owner-swap-request-block ion-avatar {
  width: 32px;
  height: 32px;
  margin-right: 10px;
}
.owner-swap-request-block ion-row + ion-row ion-col:first-child {
  padding-right: 7px;
}
.owner-swap-request-block ion-row + ion-row ion-col:last-child {
  padding-left: 7px;
}
.owner-swap-request-block .theme-btn,
.owner-swap-request-block .theme-btn-alt {
  font-size: 0.8888888889rem;
}
.owner-swap-request-block .theme-btn-alt {
  border-width: 1px;
}`, "",{"version":3,"sources":["webpack://./src/theme/variables.scss","webpack://./src/app/pages/product/product-detail/product-detail.page.scss","webpack://./src/assets/CustomCss/custom-header.scss"],"names":[],"mappings":"AAGA,0BAAA;AAEA;EACI,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EACA,iIAAA;EACA,4IAAA;EAEA,8BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,sCAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EAEA,4BAAA;ACdJ;;ADiBA;;EAEI,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EACA,iIAAA;EACA,4IAAA;EAEA,8BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,sCAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EAIA,8CAAA;EACA,sDAAA;EACA,uCAAA;EACA,+CAAA;EACA,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,kCAAA;EACA,2BAAA;EACA;;;;;;;;;GAAA;AClBJ;;AD+BA;EACE,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;AC5BF;;AD+BA;;;;;;;;;;;;;;;;CAAA;AAxMA,0BAAA;AAEA;EACI,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EACA,iIAAA;EACA,4IAAA;EAEA,8BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,sCAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EAEA,4BAAA;ACiLJ;;AD9KA;;EAEI,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EACA,iIAAA;EACA,4IAAA;EAEA,8BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,qCAAA;EACA,sCAAA;EACA,gDAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,uBAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EAIA,8CAAA;EACA,sDAAA;EACA,uCAAA;EACA,+CAAA;EACA,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,kCAAA;EACA,2BAAA;EACA;;;;;;;;;GAAA;AC6KJ;;ADhKA;EACE,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;ACmKF;;ADhKA;;;;;;;;;;;;;;;;CAAA;AExME;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;AD4XJ;AC3XI;EACE,aAAA;AD6XN;AC3XI;EACE,yBAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AD6XN;AC5XM;EACE,SAAA;AD8XR;AC7XQ;EACE,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,iCAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,mCAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;AD+XV;AC1XU;EACE,kBAAA;AD4XZ;ACzXQ;EACE,kDAAA;AD2XV;ACxXM;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;AD0XR;ACzXQ;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,gCAAA;AD2XV;AC1XU;EACE,0BAAA;EACA,YAAA;EACA,qBAAA;AD4XZ;ACvXI;EACE,wCAAA;EACA,0CAAA;ADyXN;ACxRE;EACE,gBAAA;EACA,uBAAA;AD0RJ;;AAldE;EACE,2BAAA;EACA,4BAAA;EACA,uBAAA;EACA,wBAAA;EACA,4BAAA;AAqdJ;AAldE;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,6CAAA;AAodJ;AAndI;EACE,uBAAA;AAqdN;AAndQ;EACE,sCAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iCAAA;EACA,uBAAA;AAqdV;AApdU;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;AAsdZ;AAldU;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;AAodZ;AAndY;EACE,eAAA;EACA,iCAAA;AAqdd;AAldU;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,4CAAA;AAodZ;AAndY;EACE,eAAA;EACA,cAAA;AAqdd;AApdc;EACE,cAAA;AAsdhB;AA7cI;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,4BAAA;AA+cN;AA7cQ;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;AA+cV;AA9cU;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;AAgdZ;AA/cY;EACE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;AAidd;AA5cM;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;AA8cR;AA7cQ;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,2BAAA;AA+cV;AA9cU;EACE,mBAAA;AAgdZ;AA3cI;EACE,sBAAA;AA6cN;AA5cM;EACE,wBAAA;EACA,gCAAA;EACA,iBAAA;AA8cR;AA7cQ;EACE,mBAAA;EACA,UAAA;AA+cV;AA7cY;EACE,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA+cd;AA9cc;EACE,0BAAA;EACA,gBAAA;EACA,cAAA;AAgdhB;AA7cY;EACE,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AA+cd;AA5cU;EACE,0BAAA;EACA,gBAAA;AA8cZ;AA5cU;EACE,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AA8cZ;AA7cY;EACE,eAAA;EACA,cAAA;AA+cd;AA7cY;EACE,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;AA+cd;AA5cU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA8cZ;AA7cY;EACE,WAAA;EACA,YAAA;AA+cd;AA3cY;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mCAAA;EACA,6BAAA;EACA,+BAAA;EACA,iCAAA;EACA,kBAAA;EACA,qBAAA;EACA,0BAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,oBAAA;EACA,gBAAA;EACA,aAAA;AA6cd;AA5cc;EACE,gBAAA;AA8chB;AAvcY;EACE,0BAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAycd;AAtcU;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AAwcZ;AAvcY;EACE,0BAAA;EACA,cAAA;AAycd;AAvcY;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,0BAAA;EACA,gBAAA;AAycd;AAxcc;EACE,cAAA;EACA,mBAAA;AA0chB;AAxcc;EACE,kBAAA;AA0chB;AAzcgB;EACE,yCAAA;AA2clB;AAncI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;AAqcN;AAncI;EACE,0BAAA;EACA,cAAA;EACA,gBAAA;AAqcN;AAncI;EACE,gBAAA;EACA,mDAAA;AAqcN;AAlcE;EACE,mBAAA;EACA,qBAAA;EACA,uBAAA;AAocJ;AAncI;EACE,SAAA;AAqcN;;AAhcA;EACE,2BAAA;EACA,4BAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA;AAmcF;;AAhcA;EACE,2BAAA;EACA,4BAAA;EACA,uBAAA;EACA,wBAAA;EACA,4BAAA;AAmcF;;AAjcA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AAocF;;AAjcA;EACE,kBAAA;EACA,kBAAA;AAocF;AAncE;EACE,eAAA;EACA,+BAAA;EACA,mBAAA;AAqcJ;AAncE;EACE,cAAA;EACA,0BAAA;EACA,cAAA;EACA,mBAAA;AAqcJ;AAncE;EACE,gBAAA;EACA,cAAA;AAqcJ;;AAhcE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAmcJ;AAhcI;EACE,kBAAA;AAkcN;AAhcI;EACE,iBAAA;AAkcN;AA/bE;;EAEE,0BAAA;AAicJ;AA/bE;EACE,iBAAA;AAicJ","sourcesContent":["// Ionic Variables and Theming. For more info, please see:\n// http://ionicframework.com/docs/theming/\n\n/** Ionic CSS Variables **/\n\n:root {\n    --ion-color-primary: #E82973;\n    --ion-color-primary-rgb: 232, 41, 115;\n    --ion-color-primary-contrast: #ffffff;\n    --ion-color-primary-contrast-rgb: 255, 255, 255;\n    --ion-color-primary-shade: #cd2367;\n    --ion-color-primary-tint: #F7ACC9;\n    --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);\n    --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);\n    ///\n    --ion-color-secondary: #343434;\n    --ion-color-secondary-rgb: 52, 52, 52;\n    --ion-color-secondary-contrast: #ffffff;\n    --ion-color-secondary-contrast-rgb: 255, 255, 255;\n    --ion-color-secondary-shade: #2e2e2e;\n    --ion-color-secondary-tint: #484848;\n    ///\n    --ion-color-tertiary: #007AFF;\n    --ion-color-tertiary-rgb: 0, 122, 255;\n    --ion-color-tertiary-contrast: #ffffff;\n    --ion-color-tertiary-contrast-rgb: 255, 255, 255;\n    --ion-color-tertiary-shade: #006be0;\n    --ion-color-tertiary-tint: #1a87ff;\n    ///\n    --ion-color-success: #07AE1D;\n    --ion-color-success-rgb: 7, 174, 29;\n    --ion-color-success-contrast: #ffffff;\n    --ion-color-success-contrast-rgb: 255, 255, 255;\n    --ion-color-success-shade: #06991a;\n    --ion-color-success-tint: #20b634;\n    ///\n    --ion-color-warning: #ffc409;\n    --ion-color-warning-rgb: 255, 196, 9;\n    --ion-color-warning-contrast: #000000;\n    --ion-color-warning-contrast-rgb: 0, 0, 0;\n    --ion-color-warning-shade: #e0ac08;\n    --ion-color-warning-tint: #ffca22;\n    //\n    --ion-color-danger: #E92828;\n    --ion-color-danger-rgb: 233, 40, 40;\n    --ion-color-danger-contrast: #ffffff;\n    --ion-color-danger-contrast-rgb: 255, 255, 255;\n    --ion-color-danger-shade: #cd2323;\n    --ion-color-danger-tint: #eb3e3e;\n    ///\n    --ion-color-dark: #343434;\n    --ion-color-dark-rgb: 52, 52, 52;\n    --ion-color-dark-contrast: #ffffff;\n    --ion-color-dark-contrast-rgb: 255, 255, 255;\n    --ion-color-dark-shade: #2e2e2e;\n    --ion-color-dark-tint: #484848;\n    ///\n    --ion-color-medium: #707070;\n    --ion-color-medium-rgb: 112, 112, 112;\n    --ion-color-medium-contrast: #ffffff;\n    --ion-color-medium-contrast-rgb: 255, 255, 255;\n    --ion-color-medium-shade: #636363;\n    --ion-color-medium-tint: #7e7e7e;\n    ///\n    --ion-color-light: #FCFCFF;\n    --ion-color-light-rgb: 252, 252, 255;\n    --ion-color-light-contrast: #000000;\n    --ion-color-light-contrast-rgb: 0, 0, 0;\n    --ion-color-light-shade: #F6F6F6;\n    --ion-color-light-tint: #fcfcff;\n    //__________________//\n    --ion-color-white: #fff;\n    --ion-text-color-primary: 42, 42, 42;\n    --ion-text-color-Secondary: #EF5492;\n    // Font Family\n    --ion-font-family: 'Segoe UI';\n    // Spacing\n    --app-padding-from-top: 30px;\n}\n\n.ios body,\n.md body {\n    --ion-color-primary: #E82973;\n    --ion-color-primary-rgb: 232, 41, 115;\n    --ion-color-primary-contrast: #ffffff;\n    --ion-color-primary-contrast-rgb: 255, 255, 255;\n    --ion-color-primary-shade: #cd2367;\n    --ion-color-primary-tint: #F7ACC9;\n    --ion-color-primary-grad: linear-gradient(102deg, rgba(232, 41, 115, 1) 0%, rgba(238, 85, 146, 1) 35%, rgba(239, 83, 145, 1) 70%);\n    --ion-color-primary-grad-vertical: linear-gradient(180deg, rgba(232, 41, 115, 1) 20%, rgba(238, 85, 146, 1) 72%, rgba(239, 83, 145, 1) 100%);\n    ///\n    --ion-color-secondary: #343434;\n    --ion-color-secondary-rgb: 52, 52, 52;\n    --ion-color-secondary-contrast: #ffffff;\n    --ion-color-secondary-contrast-rgb: 255, 255, 255;\n    --ion-color-secondary-shade: #2e2e2e;\n    --ion-color-secondary-tint: #484848;\n    ///\n    --ion-color-tertiary: #5260ff;\n    --ion-color-tertiary-rgb: 82, 96, 255;\n    --ion-color-tertiary-contrast: #ffffff;\n    --ion-color-tertiary-contrast-rgb: 255, 255, 255;\n    --ion-color-tertiary-shade: #4854e0;\n    --ion-color-tertiary-tint: #6370ff;\n    ///\n    --ion-color-success: #07AE1D;\n    --ion-color-success-rgb: 7, 174, 29;\n    --ion-color-success-contrast: #ffffff;\n    --ion-color-success-contrast-rgb: 255, 255, 255;\n    --ion-color-success-shade: #06991a;\n    --ion-color-success-tint: #20b634;\n    ///\n    --ion-color-warning: #ffc409;\n    --ion-color-warning-rgb: 255, 196, 9;\n    --ion-color-warning-contrast: #000000;\n    --ion-color-warning-contrast-rgb: 0, 0, 0;\n    --ion-color-warning-shade: #e0ac08;\n    --ion-color-warning-tint: #ffca22;\n    //\n    --ion-color-danger: #E92828;\n    --ion-color-danger-rgb: 233, 40, 40;\n    --ion-color-danger-contrast: #ffffff;\n    --ion-color-danger-contrast-rgb: 255, 255, 255;\n    --ion-color-danger-shade: #cd2323;\n    --ion-color-danger-tint: #eb3e3e;\n    ///\n    --ion-color-dark: #343434;\n    --ion-color-dark-rgb: 52, 52, 52;\n    --ion-color-dark-contrast: #ffffff;\n    --ion-color-dark-contrast-rgb: 255, 255, 255;\n    --ion-color-dark-shade: #2e2e2e;\n    --ion-color-dark-tint: #484848;\n    ///\n    --ion-color-medium: #707070;\n    --ion-color-medium-rgb: 112, 112, 112;\n    --ion-color-medium-contrast: #ffffff;\n    --ion-color-medium-contrast-rgb: 255, 255, 255;\n    --ion-color-medium-shade: #636363;\n    --ion-color-medium-tint: #7e7e7e;\n    ///\n    --ion-color-light: #FCFCFF;\n    --ion-color-light-rgb: 252, 252, 255;\n    --ion-color-light-contrast: #000000;\n    --ion-color-light-contrast-rgb: 0, 0, 0;\n    --ion-color-light-shade: #F6F6F6;\n    --ion-color-light-tint: #fcfcff;\n    ////////////\n    --ion-color-white: #fff;\n    --ion-text-color-primary: 42, 42, 42;\n    --ion-text-color-Secondary: #EF5492;\n    // Font Family\n    --ion-font-family: 'Segoe UI';\n    //////////\n    //////////\n    // ////////\n    --ion-background-color: var(--ion-color-light);\n    --ion-background-color-rgb: var(--ion-color-light-rgb);\n    --ion-text-color: var(--ion-color-dark);\n    --ion-text-color-rgb: var(--ion-color-dark-rgb);\n    --ion-color-step-50: #0d0d0d;\n    --ion-color-step-100: #1a1a1a;\n    --ion-color-step-150: #262626;\n    --ion-color-step-200: #333333;\n    --ion-color-step-250: #404040;\n    --ion-color-step-300: #4d4d4d;\n    --ion-color-step-350: #595959;\n    --ion-color-step-400: #666666;\n    --ion-color-step-450: #737373;\n    --ion-color-step-500: #808080;\n    --ion-color-step-550: #8c8c8c;\n    --ion-color-step-600: #999999;\n    --ion-color-step-650: #a6a6a6;\n    --ion-color-step-700: #b3b3b3;\n    --ion-color-step-750: #bfbfbf;\n    --ion-color-step-800: #cccccc;\n    --ion-color-step-850: #d9d9d9;\n    --ion-color-step-900: #e6e6e6;\n    --ion-color-step-950: #f2f2f2;\n    --ion-item-background: transparent;\n    --ion-card-background: #fff;\n    /* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)\n    @media (prefers-color-scheme: dark) {\n        --ion-background-color: #17171A;\n        --ion-background-color-rgb: 23, 23, 26;\n        --ion-text-color: #F2F2F2;\n        --ion-text-color-rgb: 242, 242, 242;\n        color: var(--ion-text-color);\n        background: var(--ion-background-color);\n    }\n    */\n}\n\n// --- Stijlgids-tokens (modernisatietraject, licht/donker via prefers-color-scheme) ---\n:root {\n  --brand: #E82973;\n  --bg-app: #FFFFFF;\n  --surface-card: #F5F5F5;\n  --border-token: #E5E5E5;\n  --text-primary-token: #1A1A1A;\n  --text-secondary-token: #777777;\n  --text-muted-token: #999999;\n}\n\n/* Dark mode tijdelijk uitgeschakeld t.b.v. testomgeving/datadump (zie overdrachtsdocument)\n@media (prefers-color-scheme: dark) {\n  :root {\n    --brand: #E82973;\n    --bg-app: #17171A;\n    --surface-card: #3F3F45;\n    --border-token: #3A3A3D;\n    --text-primary-token: #F2F2F2;\n    --text-secondary-token: #A0A0A5;\n    --text-muted-token: #6E6E73;\n    --ion-background-color: #17171A;\n    --ion-background-color-rgb: 23, 23, 26;\n    --ion-text-color: #F2F2F2;\n    --ion-text-color-rgb: 242, 242, 242;\n  }\n}\n*/\n","@import \"../../../../theme/variables.scss\";\n@import \"../../../../theme/mixins.scss\";\n@import \"../../../../assets/CustomCss/custom-header.scss\";\n:host {\n  .sc-ion-modal-md-h {\n    --max-width: 90% !important;\n    --max-height: 60% !important;\n    --width: 90% !important;\n    --height: 60% !important;\n    border-radius: 5% !important;\n  }\n\n  ion-header {\n    position: absolute;\n    top: 0px;\n    left: 0;\n    right: 0;\n    width: 100%;\n    --box-shadow: none;\n    background: transparent;\n    padding-top: 30px;\n    padding-bottom: 10px;\n    font-family: var(--ion-font-family-secondary);\n    ion-toolbar {\n      background: transparent;\n      ion-buttons {\n        ion-back-button {\n          --background: rgba(255, 255, 255, 0.8);\n          --min-height: 49px;\n          --min-width: 51px;\n          --border-radius: 14px;\n          color: var(--ion-color-secondary);\n          --icon-font-weight: 300;\n          &.edit-btn {\n            --border-radius: 50%;\n            width: 42px;\n            height: 42px;\n            --background: var(--ion-color-white);\n          }\n        }\n        ion-button {\n          &.edit-btn {\n            --border-radius: 50%;\n            width: 42px;\n            height: 42px;\n            --background: var(--ion-color-white);\n            ion-icon {\n              font-size: 25px;\n              color: var(--ion-color-secondary);\n            }\n          }\n          &.favorite-btn {\n            --border-radius: 50%;\n            width: 42px;\n            height: 42px;\n            --background: rgba(255, 255, 255, 0.85);\n            --box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n            ion-icon {\n              font-size: 22px;\n              color: #E82973;\n              &.favorited {\n                color: #E82973;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ion-content {\n    .user-profile-slider {\n      z-index: 1;\n      position: relative;\n      min-height: 200px;\n      max-height: 320px;\n      overflow: hidden;\n      box-shadow: 0 10px 50px rgba(0, 0, 0, 0.3);\n      border-radius: 0 0 20px 20px;\n      swiper-container {\n        swiper-slide {\n          margin: 0 auto;\n          min-height: 320px;\n          max-height: 320px;\n          .slideHolder {\n            position: relative;\n            min-height: 180px;\n            max-height: 320px;\n            img {\n              margin: auto;\n              max-height: 320px;\n              height: 100%;\n              object-fit: contain;\n            }\n          }\n        }\n      }\n      .slideDots {\n        position: absolute;\n        bottom: 14px;\n        left: 0;\n        right: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n        z-index: 99;\n        span {\n          width: 6px;\n          height: 6px;\n          border-radius: 50%;\n          background: rgba(255, 255, 255, 0.5);\n          transition: background 0.2s;\n          &.active {\n            background: #E82973;\n          }\n        }\n      }\n    }\n    .product-details-wrapper {\n      padding: 5px 15px 20px;\n      ion-col {\n        padding: 12px 0 12px 3px;\n        border-bottom: 1px solid #E5E5E5;\n        min-height: unset;\n        &.intro {\n          border-bottom: none;\n          padding: 0;\n          ion-text {\n            &.title {\n              font-size: calculateRem(16px);\n              font-weight: 700;\n              margin: 0 0 7px;\n              color: #1A1A1A;\n              &.userName {\n                font-size: calculateRem(14px);\n                font-weight: 700;\n                color: #1A1A1A;\n              }\n            }\n            &.date {\n              font-size: calculateRem(14px);\n              font-weight: 400;\n              margin: 0;\n              color: #777777;\n            }\n          }\n          ion-button {\n            font-size: calculateRem(17px);\n            font-weight: 600;\n          }\n          address {\n            font-size: calculateRem(16px);\n            font-weight: 400;\n            margin: 0 0 10px;\n            color: #777777;\n            display: flex;\n            align-items: center;\n            justify-content: flex-start;\n            ion-icon {\n              font-size: 14px;\n              flex-shrink: 0;\n            }\n            span {\n              max-width: 200px;\n              margin: 0px 0 0 3px;\n              font-size: calculateRem(14px);\n              font-style: normal;\n              line-height: 1.4;\n            }\n          }\n          ion-avatar {\n            max-width: 40px;\n            width: 100%;\n            height: 40px;\n            margin: 0 0 5px;\n            img {\n              width: 100%;\n              height: 100%;\n            }\n          }\n          ion-button {\n            &.btn-link {\n              --color: #E82973;\n              --padding-start: 0;\n              --padding-end: 0;\n              --padding-top: 0;\n              --padding-bottom: 0;\n              --min-height: auto;\n              --box-shadow: none;\n              --ripple-color: transparent;\n              --background-hover: transparent;\n              --background-focused: transparent;\n              --background-activated: transparent;\n              --background-hover-opacity: 0;\n              --background-focused-opacity: 0;\n              --background-activated-opacity: 0;\n              --padding-top: 8px;\n              --padding-bottom: 8px;\n              font-size: calculateRem(14px);\n              font-weight: 700;\n              height: auto;\n              min-height: 32px;\n              margin: -6px 0 -6px -8px;\n              text-transform: none;\n              box-shadow: none;\n              outline: none;\n              &::part(native) {\n                box-shadow: none;\n              }\n            }\n          }\n        }\n        &.specs {\n          ion-text {\n            &.spec-title {\n              font-size: calculateRem(14px);\n              margin: 0 0;\n              font-weight: 400;\n              color: #777777;\n            }\n          }\n          .right-content {\n            display: flex;\n            align-items: center;\n            justify-content: flex-start;\n            ion-text {\n              font-size: calculateRem(14px);\n              color: #1A1A1A;\n            }\n            .grey-block {\n              padding: 5px;\n              border-radius: 6px;\n              background: #FBEAF0;\n              color: #E82973;\n              margin: 0 8px;\n              min-width: 30px;\n              text-align: center;\n              height: 30px;\n              font-size: calculateRem(14px);\n              font-weight: 700;\n              &.active {\n                color: #E82973;\n                background: #FBEAF0;\n              }\n              &.round {\n                border-radius: 50%;\n                &.red {\n                  background-color: var(--ion-color-danger);\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    .descTitle {\n      margin: 0 0 8px;\n      line-height: 1.5;\n      font-size: calculateRem(16px);\n      font-weight: 700;\n      color: #1A1A1A;\n    }\n    h5.descTitle + ion-text {\n      font-size: calculateRem(14px);\n      color: #777777;\n      line-height: 1.5;\n    }\n    .notifications {\n      margin-top: 27px;\n      background: rgba(var(--ion-color-primary-rgb), 0.1);\n    }\n  }\n  ion-footer {\n    background: #FFFFFF;\n    --background: #FFFFFF;\n    padding: 20px 23px 30px;\n    ion-button {\n      margin: 0;\n    }\n  }\n}\n\n.sc-ion-modal-md-h {\n  --max-width: 90% !important;\n  --max-height: 60% !important;\n  --width: 90% !important;\n  --height: 60% !important;\n  --border-radius: 5% !important;\n}\n\n.my-custom-class {\n  --max-width: 90% !important;\n  --max-height: 60% !important;\n  --width: 90% !important;\n  --height: 60% !important;\n  border-radius: 5% !important;\n}\n.zoom-img {\n  width: 100%;\n  height: auto;\n  display: block;\n  touch-action: none; // helps with pinch zoom compatibility\n}\n\n.product-not-found-block {\n  text-align: center;\n  padding: 40px 20px;\n  ion-icon {\n    font-size: 48px;\n    color: var(--ion-color-primary);\n    margin-bottom: 12px;\n  }\n  ion-text {\n    display: block;\n    font-size: calculateRem(16px);\n    color: #1A1A1A;\n    margin-bottom: 20px;\n  }\n  .theme-btn {\n    max-width: 260px;\n    margin: 0 auto;\n  }\n}\n\n.owner-swap-request-block {\n  ion-avatar {\n    width: 32px;\n    height: 32px;\n    margin-right: 10px;\n  }\n  ion-row + ion-row {\n    ion-col:first-child {\n      padding-right: 7px;\n    }\n    ion-col:last-child {\n      padding-left: 7px;\n    }\n  }\n  .theme-btn,\n  .theme-btn-alt {\n    font-size: calculateRem(16px);\n  }\n  .theme-btn-alt {\n    border-width: 1px;\n  }\n}\n","@import \"../../theme/variables.scss\";\n@import \"../../theme/mixins.scss\";\n:host {\n  ion-header {\n    position: relative;\n    top: 0px;\n    left: 0;\n    right: 0;\n    width: 100%;\n    --box-shadow: none;\n    box-shadow: none;\n    background: transparent;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    --background: transparent;\n    &:after {\n      display: none;\n    }\n    ion-toolbar {\n      --background: transparent;\n      --border-width: 0px;\n      color: var(--ion-color-secondary);\n      --min-height: 40px;\n      --padding-bottom: 5px;\n      --padding-top: 5px;\n      --padding-start: 20px;\n      --padding-end: 15px;\n      --box-shadow: none;\n      position: relative;\n      ion-buttons {\n        margin: 0;\n        ion-button {\n          margin: 0;\n          --background: transparent;\n          box-shadow: none;\n          --background-focused: transparent;\n          --background-focused-opacity: 0;\n          --background-hover: transparent;\n          --background-hover-opacity: 0;\n          --background-activated: transparent;\n          --background-activated-opacity: 0;\n          --border-radius: 0;\n          border-radius: 0;\n          --color: var(--ion-color-secondary);\n          --padding-end: 0;\n          --padding-top: 3px;\n          --padding-bottom: 3px;\n          --padding-start: 0;\n          font-size: 24px;\n          // padding: 0;\n          // &::part(native) {\n          //     padding: 0;\n          // }\n          .menu-btn {\n            position: relative;\n          }\n        }\n        ion-back-button {\n          --color: rgba(var(--ion-color-secondary-rgb), 0.9);\n        }\n      }\n      ion-title {\n        text-align: center;\n        font-size: calculateRem(24px);\n        font-weight: 600;\n        position: absolute;\n        left: 50%;\n        padding: 0;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        max-width: 200px;\n        line-height: 1.5;\n        &.logo {\n          position: absolute;\n          left: 50%;\n          right: 0;\n          top: 50%;\n          padding: 0;\n          transform: translate(-50%, -50%);\n          img {\n            max-width: calculateRem(131px);\n            height: auto;\n            display: inline-block;\n          }\n        }\n      }\n    }\n    &.greyHeader {\n      background: var(--ion-color-light-shade);\n      --background: var(--ion-color-light-shade);\n    }\n    // &.curved-header {\n    //     position: relative;\n    //     padding-top: 0px;\n    //     padding-bottom: 0px;\n    //     height: 75px;\n    //     display: flex;\n    //     align-items: center;\n    //     justify-content: stretch;\n    //     &:after {\n    //         background: var(--ion-color-primary-tint);\n    //         left: 25px;\n    //         right: 25px;\n    //         bottom: 0;\n    //         height: 15px;\n    //         border-radius: 24px 24px 0 0;\n    //         position: absolute;\n    //         width: auto;\n    //     }\n    //     ion-toolbar {\n    //         position: relative;\n    //         --min-height: 50px;\n    //         --background: transparent;\n    //         --border-width: 0px;\n    //         color: var(--ion-color-white);\n    //         --padding-top: 0;\n    //         --padding-bottom: 0px;\n    //         --padding-start: 18px;\n    //         --padding-end: 18px;\n    //         --box-shadow: none;\n    //         ion-buttons {\n    //             margin: 0px;\n    //             .menu-btn {}\n    //             ion-back-button {\n    //                 --border-radius: 4px;\n    //                 --background: rgba(255, 255, 255, 0.678);\n    //                 --min-height: 43px;\n    //                 --min-width: 45px;\n    //                 --border-radius: 14px;\n    //                 color: var(--ion-color-secondary);\n    //                 --icon-font-weight: 300;\n    //             }\n    //             ion-menu-button,\n    //             ion-button {\n    //                 --background: transparent;\n    //                 box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.05);\n    //                 --background-focused: #fff;\n    //                 --background-focused-opacity: 1;\n    //                 --background-hover: #fff;\n    //                 --background-hover-opacity: 1;\n    //                 --border-radius: 14px;\n    //                 border-radius: 14px;\n    //                 color: var(--ion-color-white);\n    //                 --padding-bottom: 0;\n    //                 --padding-top: 0;\n    //                 --padding-bottom: 0;\n    //                 --padding-bottom: 0;\n    //                 width: 45px;\n    //                 height: 43px;\n    //                 span {\n    //                     color: var(--ion-color-white);\n    //                 }\n    //                 &.bg-white {\n    //                     --border-radius: 4px;\n    //                     --background: rgba(255, 255, 255, 0.678);\n    //                     --min-height: 43px;\n    //                     --min-width: 45px;\n    //                     --border-radius: 14px;\n    //                     color: var(--ion-color-secondary);\n    //                     --icon-font-weight: 300;\n    //                 }\n    //             }\n    //         }\n    //         ion-title {\n    //             text-align: center;\n    //             color: var(--ion-color-white);\n    //             font-size: calculateRem(20px);\n    //             position: absolute;\n    //             left: 50%;\n    //             padding: 0;\n    //             top: 50%;\n    //             transform: translate(-50%, -50%);\n    //             max-width: 200px;\n    //             line-height: 1.5;\n    //         }\n    //         ion-avatar {\n    //             width: 45px;\n    //             height: 45px;\n    //             img {\n    //                 height: auto;\n    //                 max-width: 100%;\n    //             }\n    //         }\n    //     }\n    // }\n  }\n  ion-content {\n    --padding-top: 0;\n    --offset-bottom: -100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
